<div class="bgDiv" style="width: 100%; height: 100%;">
  <mat-progress-bar mode="query" color="primary" dir="rtl" *ngIf="!loginInvalid"></mat-progress-bar>

  <mat-card class="center">
    <mat-card-content>
      <img src="assets/backtrace_logo.png" alt="BackTrace" style="width: 100%"/>
      <hr>

      <mat-spinner mode="indeterminate" class="center-loader" *ngIf="!loginInvalid"></mat-spinner>
      <h3 class="center-loader" *ngIf="!loginInvalid" style="font-weight: bold">Authenticating</h3>


      <mat-error *ngIf="loginInvalid" style="color: red; font-weight: bold; font-size: 18pt">
        <a mat-stroked-button href="https://backtracereports.com" style="color: darkblue;">Login via BackTrace Reports</a>
      </mat-error>


    </mat-card-content>
  </mat-card>


</div>
